import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Metrics from '@spotahome/soyuz-metrics';
import { trans } from '@spotahome/bff/client';

import { getSortingOptions } from '../utils/sorting';

import './SortBy.scss';

const OPTIONS = getSortingOptions();

class SortBy extends PureComponent {
  propTypes = {
    handleSortByChange: PropTypes.func.isRequired,
    orderBy: PropTypes.string.isRequired
  };

  handleChange = e => {
    Metrics.ga.sendEvent('Search', 'sort-by', e.target.value);
    this.props.handleSortByChange(e.target.value);
  };

  render() {
    return (
      <div className="sort-by">
        <span className="sort-by__title">
          {trans('search.filter_header.sort_by')}
        </span>
        <span className="sort-by__select-wrapper">
          <select
            className="sort-by__select"
            onChange={this.handleChange}
            value={this.props.orderBy}
          >
            {OPTIONS.map(option => (
              <option value={option.value}>{trans(option.key)}</option>
            ))}
          </select>
        </span>
      </div>
    );
  }
}

export default SortBy;
